module.exports = __webpack_public_path__ + "images/location-cluster.f043c6d96f2e56886c62.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/location-cluster.svg
// module id = ZHMR
// module chunks = 24